import { Injectable, signal, computed, inject } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { DateUtilService } from './dateUtil.service';


@Injectable({
  providedIn: 'root'
})
export class LeadsStateService {
  private readonly analyticsService = inject(AnalyticsService);
  private dataHoje = inject(DateUtilService).dataHoje;



  // 1. Estado Privado (Source of Truth)
  private readonly _totalOntem = signal<number>(0);
  private readonly _leadsHoje = signal<number>(0);

  private readonly _leadsSemana = signal<number>(0);

  private readonly _percentualEvolucao = signal<number>(0);
  private readonly _loading = signal<boolean>(false);

  // 2. Exposição Pública (Read-only)
  readonly totalLeadsHoje = this._leadsHoje.asReadonly();
  readonly totalLeadsSemana = this._leadsSemana.asReadonly();
  readonly totalLeadsOntem = this._totalOntem.asReadonly();
  readonly percentualEvolucao = this._percentualEvolucao.asReadonly();

  readonly isLoading = this._loading.asReadonly();

  /**
   * Busca dados da API e atualiza o estado global
   */
  public refreshTotalLeads(): void {

    
    this._loading.set(true);
    
    this.analyticsService.evolucaoDiaria()
      .subscribe({
        next: (evolucaoDiaria) => {
          this._leadsHoje.set(evolucaoDiaria.leadsHoje);
          this._totalOntem.set(evolucaoDiaria.leadsOntem);
          this._leadsSemana.set(evolucaoDiaria.leadsSemana);
        
          var percentualEvolucao = ((evolucaoDiaria.leadsOntem - evolucaoDiaria.leadsHoje) / evolucaoDiaria.leadsOntem * 100) * -1;
          this._percentualEvolucao.set(percentualEvolucao);
         
          

          this._loading.set(false);
        },
        error: () => this._loading.set(false)
      });


  }

  public incrementOptimistic(): void {
    this._leadsHoje.update(current => current + 1);
  }


}